import * as dateFns from 'date-fns';
import { enUS, nb } from 'date-fns/locale';
import i18n from '../../i18n';
import {
    MESSAGES_HEADINGS
} from '../../constants/pushMessages';

export const prepareRowData = (currentMsg) => {
    const locale = (i18n.language === 'no') ? nb : enUS;
    if (currentMsg) {
        return {
            [MESSAGES_HEADINGS.MESSAGE_ID]: currentMsg.id || '-',
            ...(!currentMsg.admin && {
                [MESSAGES_HEADINGS.RECEIVER_ID]: currentMsg.userId || currentMsg.topic || '-',
            }),
            [MESSAGES_HEADINGS.DATE]: currentMsg.timestamp._seconds ?
                dateFns.format(new Date(currentMsg.timestamp._seconds * 1000), 'd MMMM yyyy HH:mm', {locale}) :
                '-',
            [MESSAGES_HEADINGS.TITLE]: currentMsg.title || '-',
            [MESSAGES_HEADINGS.MESSAGE]: currentMsg.body || '-',
            ...(currentMsg.admin && {
                [MESSAGES_HEADINGS.SIGNATURE]: currentMsg.admin.signatureType || '-',
            }),
            ...(currentMsg.userIds && {
                [MESSAGES_HEADINGS.CANDIDATE]: currentMsg.userIds.length || '-',
            }),
        }
    } 
};

export const prepareRowDataForSorting = (currentMsg) => {
    if (currentMsg) {
        return {
            [MESSAGES_HEADINGS.MESSAGE_ID]: currentMsg.id || '-',
            ...(!currentMsg.admin && {
                [MESSAGES_HEADINGS.RECEIVER_ID]: currentMsg.userId || currentMsg.topic || '-',
            }),
            [MESSAGES_HEADINGS.DATE]: currentMsg.timestamp?._seconds || 0,
            [MESSAGES_HEADINGS.TITLE]: currentMsg.title || '-',
            [MESSAGES_HEADINGS.MESSAGE]: currentMsg.body || '-',
            ...(currentMsg.admin && {
                [MESSAGES_HEADINGS.SIGNATURE]: currentMsg.admin.signatureType || '-',
            }),
            ...(currentMsg.userIds && {
                [MESSAGES_HEADINGS.CANDIDATE]: currentMsg.userIds.length || '-',
            }),
        }
    }
};

export const sortTableData = (tableData, sortKey, clicks) => {
    let newTableData = [...tableData];

    if (tableData.length > 1) {
        let value = 0;

        if (typeof tableData[0].sortable?.[sortKey] === 'string') {
            newTableData = newTableData.sort(
                (a, b) => {
                    if (a.sortable[sortKey] === "-") {
                        return 1;
                    }
                    if (a.sortable[sortKey] > b.sortable[sortKey]) {
                        value = clicks % 2 ? -1 : 1;
                    }
                    if (a.sortable[sortKey] < b.sortable[sortKey]) {
                        value = clicks % 2 ? 1 : -1;
                    }
                    return value;
                },
            );
        }

        if (typeof tableData[0].sortable?.[sortKey] === 'number') {
            newTableData = newTableData.sort(
                (a, b) => {
                    if (a.sortable[sortKey] === 0) {
                        return 1;
                    }
                    if (+a.sortable[sortKey] > +b.sortable[sortKey]) {
                        value = clicks % 2 ? -1 : 1;
                    }
                    if (+a.sortable[sortKey] < +b.sortable[sortKey]) {
                        value = clicks % 2 ? 1 : -1;
                    }
                    return value;
                },
            );
        }
    }
    return [...newTableData];
};